module.exports = __webpack_public_path__ + "static/media/incognito .3c8a2cb1.svg";